export default __webpack_public_path__ + "static/media/interno_3.6b7f1521.jpg";